import React from 'react';
import { BookmarkProvider } from './contexts/BookmarkContext';
import { BrowserProvider } from './contexts/BrowserContext';
import Router from './Router';
import EmbedRouter from './EmbedRouter';

// NOTE: HelmetProvider is supplied by the entry points (entry-client.tsx and
// entry-server.tsx). It must NOT be nested here — a second provider would
// capture Helmet output into its own context and leave the server's
// helmetContext empty, so SSR/prerender would inject an empty <head>.
function App() {
  return (
    <BrowserProvider>
      <BookmarkProvider>
        <Router />
        <EmbedRouter />
      </BookmarkProvider>
    </BrowserProvider>
  );
}

export default App;